<div class="container h-100 d-flex flex-column align-items-center justify-content-center py-3">
  <div class="logo mx-auto mb-4 flex-shrink-0">
    <img src="assets/images/logo.png" class="img-fluid" alt="LOGO">
  </div>
  <div class="card shadow px-5 py-4 mx-auto d-grid gap-3 card-login flex-shrink-0 w-100">
    <div class="mb-3 h5 fw-bold text-center">
      {{ 'app.login.title' | translate }}
    </div>
    <form [formGroup]="loginForm" (ngSubmit)="onLogin()" class="d-grid gap-3">
      <div>
        <label for="email-input" class="form-label">{{
          'app.login.email' | translate
        }}</label>
        <input
          formControlName="email"
          type="text"
          class="form-control"
          id="input-email"
          required
        />
        <div class="text-danger">
          @if (email?.invalid && (email?.dirty || email?.touched)) {
            @if (email?.hasError('required')) {
              {{ 'app.login.emailRequired' | translate }}
            }
            @if (email?.hasError('email')) {
              {{ 'app.login.emailValidate' | translate }}
            }
          }
        </div>
      </div>
      <div>
        <label for="password-input" class="form-label">{{
          'app.login.password' | translate
        }}</label>
        <input
          formControlName="password"
          type="{{ isShowPwd.value ? 'text' : 'password' }}"
          class="form-control"
          id="input-password"
          autocomplete="on"
          required
        />
        <div class="text-danger">
          @if (password?.invalid && (password?.dirty || password?.touched)) {
            @if (password?.hasError('required')) {
              {{ 'app.login.passwordRequired' | translate }}
            }
          }
        </div>
      </div>
      <div class="form-check">
        <input
          [formControl]="isShowPwd"
          type="checkbox"
          class="form-check-input"
          id="show-password-checkbox"
        />
        <label for="show-password-checkbox" class="form-check-label">{{
          'app.login.showPassword' | translate
        }}</label>
      </div>
      <div>
        <button
          [disabled]="isLoggingIn"
          type="submit"
          class="btn btn-primary w-100 btn-login"
        >
          {{ 'app.login.button' | translate }}
          @if (isLoggingIn) {
            <div
              class="spinner-border spinner-border-sm text-light"
              role="status"
            ></div>
          }
        </button>
      </div>
    </form>
    <div class="text-center d-grid gap-1">
      <div>
        <span>{{ 'app.login.registerTip' | translate }}</span>
        <a routerLink="/auth/register" class="ps-1">{{
          'app.login.registerLink' | translate
        }}</a>
      </div>
      <div>
        <a routerLink="/auth/forgot-password">{{
          'app.login.forgotPassword' | translate
        }}</a>
      </div>
    </div>
  </div>
</div>
